import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Arrow() {
	const classes = useStyles();

	return (
		<svg width="27px" height="27px" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
			<title>Arrow</title>
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="Arrow" transform="translate(0.500000, 0.500000)">
					<circle id="Oval" stroke="#FF3426" cx="12.61" cy="12.61" r="12.61"></circle>
					<polyline
						id="Path"
						stroke="#F81937"
						stroke-width="1.3"
						stroke-linecap="round"
						stroke-linejoin="round"
						points="9.93 18.24 16.01 12.43 9.93 6.99"
					></polyline>
				</g>
			</g>
		</svg>
	);
}
